import { Inbox, AlertCircle, Loader2 } from 'lucide-react'

interface EmptyStateProps {
  variant?: 'empty' | 'error' | 'loading'
  title?: string
  description?: string
  action?: { label: string; onClick: () => void }
}

const EmptyState = ({ variant = 'empty', title, description, action }: EmptyStateProps) => {
  if (variant === 'loading') {
    return (
      <div className="flex justify-center items-center py-12">
        <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
      </div>
    )
  }
  const Icon = variant === 'error' ? AlertCircle : Inbox
  const colorCls = variant === 'error' ? 'text-red-400' : 'text-gray-400'
  const defaultTitle = variant === 'error' ? '加载失败' : '暂无内容'
  const defaultDesc = variant === 'error' ? '请检查网络后重试' : '换个分类试试，或清除筛选条件'
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <Icon className={`w-12 h-12 ${colorCls} mb-3`} />
      <p className="text-gray-600 font-medium">{title || defaultTitle}</p>
      <p className="text-gray-400 text-sm mt-1">{description || defaultDesc}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-4 px-4 py-1.5 bg-green-600 text-white rounded-full text-sm hover:bg-green-700 transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}

export default EmptyState
